import React, { memo } from 'react';
import { CategoryLandingPageSectionBlokProps } from './CategoryLandingPage';
import CategoryLandingPageSideBarDesktopListItem from './CategoryLandingPageSideBarDesktopListItem';

interface CategoryLandingPageSideBarDesktopListProps {
  categoryLandingPageSections: CategoryLandingPageSectionBlokProps[];
  activeCategoryLandingPageSection: string;
}

const CategoryLandingPageSideBarDesktopList: React.FC<
  CategoryLandingPageSideBarDesktopListProps
> = ({ categoryLandingPageSections, activeCategoryLandingPageSection }) => {
  return (
    <ul>
      {categoryLandingPageSections.map(
        (
          categoryLandingPageSection: CategoryLandingPageSectionBlokProps,
          index: number
        ) => (
          <CategoryLandingPageSideBarDesktopListItem
            key={categoryLandingPageSection._uid}
            categoryLandingPageSection={categoryLandingPageSection}
            categoryLandingPageSectionIndex={index}
            isLastItem={categoryLandingPageSections.length - 1 == index}
            activeCategoryLandingPageSection={activeCategoryLandingPageSection}
          />
        )
      )}
    </ul>
  );
};

export default CategoryLandingPageSideBarDesktopList;
